module.exports = __webpack_public_path__ + "img/bluesubtract.e175ff97.png";